<template>
  <div class="editor-container">
    <div class="mask" v-if="disabled"></div>
    <quill-editor
      ref="myTextEditor"
      v-model="contentValue"
      :options="editorOption"
      :contenteditable="false"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @ready="onEditorReady($event)"
      @change="onEditorChange($event)"
      :class="['ql-editor', 'cfpa-quill-editor']"
    >
      <div id="toolbar" slot="toolbar">
        <!-- Add a bold button -->
        <button class="ql-bold" title="加粗">Bold</button>
        <button class="ql-italic" title="斜体">Italic</button>
        <button class="ql-underline" title="下划线">underline</button>
        <button class="ql-strike" title="删除线">strike</button>
        <button class="ql-blockquote" title="引用"></button>
        <!-- <button class="ql-code-block" title="代码"></button> -->
        <button class="ql-header" value="1" title="标题1"></button>
        <button class="ql-header" value="2" title="标题2"></button>
        <!--Add list -->
        <button class="ql-list" value="ordered" title="有序列表"></button>
        <button class="ql-list" value="bullet" title="无序列表"></button>
        <!-- Add font size dropdown -->
        <select class="ql-header" title="段落格式">
          <option selected>段落</option>
          <option value="1">标题1</option>
          <option value="2">标题2</option>
          <option value="3">标题3</option>
          <option value="4">标题4</option>
          <option value="5">标题5</option>
          <option value="6">标题6</option>
        </select>
        <select class="ql-size" title="字体大小(适配移动端rpx)">
          <option value="8px">16rpx</option>
          <option value="9px">18rpx</option>
          <option value="10px">20rpx</option>
          <option value="11px">22rpx</option>
          <option value="12px">24rpx</option>
          <option value="13px" selected>26rpx</option>
          <option value="14px">28rpx</option>
          <option value="15px">30rpx</option>
          <option value="16px">32rpx</option>
          <option value="17px">34rpx</option>
          <option value="18px">36rpx</option>
        </select>
        <select class="ql-font" title="字体" style="width: 160px;">
          <option value="PingFangRegular" selected>PingFangRegular</option>
          <option value="PingFangBold">PingFangBold</option>
          <option value="PingFangExtraLight">PingFangExtraLight</option>
          <option value="PingFangHeavy">PingFangHeavy</option>
          <option value="PingFangLight">PingFangLight</option>
          <option value="PingFangMedium">PingFangMedium</option>
        </select>
        <!-- Add subscript and superscript buttons -->
        <select class="ql-color" value="color" title="字体颜色"></select>
        <select
          class="ql-background"
          value="background"
          title="背景颜色"
        ></select>
        <select class="ql-align" value="align" title="对齐"></select>
        <button class="ql-clean" title="还原"></button>
        <button class="ql-link" title="超链接"></button>
        <!-- You can also add your own -->
        <button
          id="custom-button"
          @click.prevent="fnOpenUploadImage"
          title="图片"
        >
          <i class="iconfont el-icon-picture"></i>
        </button>
        <button
          id="custom-button"
          @click.prevent="fnOpenUploadVideo"
          title="视频"
        >
          <i class="iconfont el-icon-video-play"></i>
        </button>
      </div>
    </quill-editor>
    <div class="number">{{ showWordNumber }} / {{ maxWordNumber }}</div>
    <el-dialog
      :title="title"
      width="30%"
      :visible.sync="dialogFnOpenUpload"
      :close-on-click-modal="false"
    >
      <file-upload
        :data="{fileType: uploadType, sourceType}"
        @fnUploadSucess="fnUploadSucess"
        @fnCloseDialog="dialogFnOpenUpload = false"
        ref="fileUpload"
        :types="
          uploadType === 'video'
            ? ['video/mp4']
            : ['image/jpeg', 'image/png', 'image/jpg']
        "
      ></file-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFnOpenUpload = false">取消</el-button>
        <el-button type="primary" @click="fnOpenUploadSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import fileUpload from './editor/image.vue'
import { Quill, quillEditor } from 'vue-quill-editor'
// 图片可收缩
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'

// 这里引入修改过的video模块并注册
import Video from './editor/video'
Quill.register(Video, true)
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

// 自定义字体大小
let Size = Quill.import('attributors/style/size')
Size.whitelist = ['8px', '9px', '10px', '11px', '12px', '13px', '14px', '15px', '16px', '17px', '18px']
Quill.register(Size, true)

// // 自定义字体类型
const fonts = ['PingFangRegular', 'PingFangBold', 'PingFangExtraLight', 'PingFangHeavy', 'PingFangLight', 'PingFangMedium']
const Font = Quill.import('attributors/style/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  name: 'editor',
  components: {
    quillEditor,
    fileUpload
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    sourceType: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    editorHeight: {
      type: Number,
      default: 355
    },
    editorWordCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      contentValue: '',
      preContent: '',
      dialogFnOpenUpload: false,
      uploadType: 'image',
      editorOption: {
        modules: {
          toolbar: '#toolbar',
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false
          },
          imageDrop: true,
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white'
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar']
          }
        },
        placeholder: '请编写内容...',
        theme: 'snow'
      },
      contentLength: 0,
      wordCount: '',
      showWordNumber: 0,
      maxWordNumber: 500,
      title: '添加图片',
      quillEditorHeight: 300
    }
  },
  computed: {
    editor () {
      return this.$refs.myTextEditor.quill
    }
  },
  methods: {
    /**
     * @description [onEditorBlur 失去焦点]
     * @author   zoumiao
     * @param {Object} editor 返回的quill对象
     * @return   {null}   [没有返回]
     */
    onEditorBlur (editor) {
      this.$emit('editorBlur')
    },
    /**
     * @description [onEditorFocus 获取焦点]
     * @author   zoumiao
     * @param {Object} editor 返回的quill对象
     * @return   {null}   [没有返回]
     */
    onEditorFocus (editor) {
      editor.enable(!this.disabled)
      this.$emit('editorFocus')
    },
    /**
     * @description [onEditorReady 可以输入]
     * @author   zoumiao
     * @param {Object} editor 返回的quill对象
     * @return   {null}   [没有返回]
     */
    onEditorReady (editor) {
      editor.enable(!this.disabled)
    },
    onEditorInput () {
      let _myQuillEditor7 = this.$refs.myTextEditor
      this.showWordNumber = _myQuillEditor7.quill.getText().length - 1

      if (this.showWordNumber > this.maxWordNumber) {
        this.$message.error(`最多输入${this.maxWordNumber}字`)
        let _text = _myQuillEditor7.quill
            .getText()
            .slice(0, this.maxWordNumber)
        this.$refs.myQuillEditor7.quill.setText(_text)
      }
    },
    /**
     * @description [onEditorChange 输入文本改变事件]
     * @author   zoumiao
     * @param {Object} editor 返回的编辑对象{html, text, quill}
     * @return   {null}   [没有返回]
     */
    onEditorChange (editor) {
      editor.quill.deleteText(this.maxWordNumber, 4)
      if (this.contentValue === '') {
        this.showWordNumber = 0
      } else {
        let html = editor.html
        html = html.slice(0, this.maxWordNumber)
        this.preContent = html
        this.$emit('input', html)
        this.showWordNumber = editor.quill.getLength() - 1
      }
    },
    /**
     * @description [fnOpenUploadImage 上传图片]
     * @author   zoumiao
     * @return   {null}   [没有返回]
     */
    fnOpenUploadImage () {
      this.uploadType = 'image'
      this.title = '添加图片'
      this.dialogFnOpenUpload = true
    },
    /**
     * @description [fnOpenUploadVideo 上传视频]
     * @author   zoumiao
     * @return   {null}   [没有返回]
     */
    fnOpenUploadVideo () {
      this.uploadType = 'video'
      this.title = '添加视频'
      this.dialogFnOpenUpload = true
    },
    /**
     * [fnOpenUploadSubmit 提交上传文件]
     * @author   zoumiao
     * @return   {null}   [没有返回]
     */
    async fnOpenUploadSubmit () {
      await this.$refs.fileUpload.$refs.upload.submit()
    },
    /**
     * [fnUploadSucess 上传文件成功]
     * @author   zoumiao
     * @param {Array} uploadFileUrlList [上传文件返回的url]
     * @return   {null}   [没有返回]
     */
    fnUploadSucess (uploadFileUrlList) {
      let url = uploadFileUrlList
      // if (this.uploadType === 'video') {
      //   url = `${uploadFileUrlList}?x-oss-process=video/snapshot,t_0,f_jpg`
      // }
      this.editor.focus()
      this.editor.insertEmbed(this.editor.getSelection().index, this.uploadType, url)
      this.dialogFnOpenUpload = false
      this.$emit('uploadSuccess', url)
    }
  },
  created () {
    // this.quillEditorHeight = document.body.clientHeight - this.editorHeight
    this.contentValue = this.value
    this.contentLength = this.editorWordCount || 0
  },
  mounted () {
    let toolbar = document.querySelector('div.ql-toolbar.ql-snow')
    if (toolbar) {
      let toolbarHeight = toolbar.offsetHeight
      this.wordCount = {
        'top': `${toolbarHeight}px`
      }
      return
    }
    this.wordCount = {
      'top': '42px'
    }
  },
  beforeDestroy () {
    this.editor.setText('\n')
  },
  watch: {
    // Watch content change
    value (newVal, oldVal) {
      if (newVal && newVal !== this.preContent) {
        this.preContent = newVal
        this.contentValue = newVal
      } else if (!newVal) {
        this.contentValue = ''
      }
    }
  }
}
</script>
<style lang="scss">
.editor-container {
  height: 100%;
  width: 100%;
  position: relative;
  .mask {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
  }
  .number {
    position: absolute;
    right: 30px;
    bottom: 10px;
  }
}
.cfpa-quill-editor {
  line-height: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .ql-snow {
    background-color: #ffffff;
  }
  .ql-container {
    height: 0;
    flex-grow: 1;
  }
}
.cfpa-quill-wordCount {
  background-color: #ffffff;
  position: relative;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  line-height: 20px;
  font-size: 12px;
  .cfpa-quill-wordCount-text {
    text-align: right;
    margin-right: 10px;
    color: #aaa;
  }
}
</style>